// extracted by mini-css-extract-plugin
export var container = "_4e-0";
export var disabled = "_4e-4";
export var fullWidth = "_4e-3";
export var lined = "_4e-1";
export var selected = "_4e-5";
export var tab = "_4e-2";